import React from 'react'
import { DatePicker as AntdDatePicker, ConfigProvider } from 'antd'
import dayjs from 'dayjs'
import { Form } from 'react-bootstrap'

export default function DatePicker(props) {

    const { label_name, placeholder, name, value, onChange,isDobDisabled, onBlur, error, mandatory, reference, tabIndex } = props
    return (
        <>
            <Form.Group className="mb-2" controlId="date">
                {label_name && (
                    <Form.Label className={mandatory ? 'form_label_red' : 'form_label'}>{label_name}</Form.Label>
                )}
                <ConfigProvider
                    theme={{
                        components: {
                            DatePicker: {
                                borderColor: 'hsl(0, 0%, 80%)',
                                activeBorderColor: '#2c3e50',
                                activeOutlineColor: 'none',
                                hoverBorderColor: 'none',
                                activeShadow: 'none',
                                zIndexPopup: '99999',
                            },
                        },
                        token: {
                            colorBorder: '#ccc',
                            fontFamily: 'Lexend Deca'
                        },
                    }}
                >
                    <AntdDatePicker
                        ref={reference}
                        className='form-control form_input'
                        placeholder={placeholder}
                        format={'DD/MM/YYYY'}
                        name={name}
                        disabled={isDobDisabled}
                        value={value ? dayjs(value, 'DD/MM/YYYY') : ''}
                        onChange={onChange}
                        onBlur={onBlur}
                        tabIndex={tabIndex}
                    />
                </ConfigProvider>
                {error}
            </Form.Group>
        </>
    )
}
